(function () {
  'use strict';

  /* Measure the announcement bar so the overlay header can sit under it. */
  function measureAnnouncement() {
    const ann = document.querySelector('[data-bae-announce]');
    const h = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--bae-ann-h', h + 'px');
  }
  measureAnnouncement();
  window.addEventListener('resize', measureAnnouncement);
  window.addEventListener('load', measureAnnouncement);

  class BaeHeader extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-bae-fly]'));
      this.items.forEach((item) => this.bind(item));
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
      this.overlay();
    }

    bind(item) {
      const btn = item.querySelector('.bae-hdr__link');
      const panel = item.querySelector('.bae-fly');
      if (!btn || !panel) return;
      let timer;

      const open = () => {
        clearTimeout(timer);
        this.closeAll(item);
        panel.hidden = false;
        requestAnimationFrame(() => item.classList.add('is-open'));
        btn.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        clearTimeout(timer);
        timer = setTimeout(() => { if (!item.classList.contains('is-open')) panel.hidden = true; }, 280);
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      btn.addEventListener('click', (e) => { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); btn.focus(); } });
      item._close = close;
    }

    closeAll(except) {
      this.items.forEach((i) => { if (i !== except && i._close) i._close(); });
    }

    overlay() {
      if (!this.classList.contains('bae-hdr--overlay')) return;
      const onScroll = () => {
        const ann = document.querySelector('[data-bae-announce]');
        const annH = ann ? ann.getBoundingClientRect().height : 0;
        this.classList.toggle('is-solid', window.scrollY > annH + 10);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }
  if (!customElements.get('bae-header')) customElements.define('bae-header', BaeHeader);

  const drawer = document.querySelector('[data-bae-hdrdrawer]');
  if (drawer) {
    const panel = drawer.querySelector('.bae-hdrdrawer__panel');
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      const first = panel.querySelector('a, button');
      if (first) first.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { drawer.hidden = true; }, 320);
      if (lastFocus) lastFocus.focus();
    };
    document.querySelectorAll('[data-bae-hdrdrawer-open]').forEach((b) => b.addEventListener('click', open));
    document.querySelectorAll('[data-bae-hdrdrawer-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  document.addEventListener('bae:cart:updated', (e) => {
    const c = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (c === null) return;
    document.querySelectorAll('[data-bae-cart-count]').forEach((el) => {
      el.textContent = c;
      el.classList.toggle('is-empty', c === 0);
    });
  });
})();
